// @flow

export default function FedEx() {
  return (
    <span>
      Free <span style={{ color: '#2b017c', fontWeight: 'bold' }}>Fed</span>
      <span style={{ color: '#ff5900', fontWeight: 'bold' }}>Ex</span>
    </span>
  );
}
